import { featureCollection, lineString } from "@turf/helpers";
import cities from "../config/city";
import theme from "../config/theme";
import { GetItinerary, GetLoop, GetLabelLocation } from "../config/api";

export const SEARCH_ITINERAIRE = "search/SEARCH_ITINERAIRE";
export const SEARCH_LOOP = "search/SEARCH_LOOP";
export const RESET_RESULTS = "search/RESET_RESULTS";
export const SELECT_THEME = "search/SELECT_THEME";
export const LOADING = "search/LOADING";
export const SELECT_RESULT = "search/SELECT_RESULT";
export const RESET_THEME = "search/RESET_THEME";
export const CHANGE_MODE = "search/CHANGE_MODE";
export const SWITCH_MENU_STATE = "search/SWITCH_MENU_STATE";
export const UPDATE_DEPARTURE = "search/UPDATE_DEPARTURE";
export const UPDATE_DESTINATION = "search/UPDATE_DESTINATION";
export const CHANGE_MODE_TABS = "search/CHANGE_MODE_TABS";
export const GET_LOOP_DATA = "search/GET_LOOP_DATA";

const initialState = {
  cities,
  results: [],
  selectedTheme: {},
  selectedResult: -1,
  isLoading: false,
  mode: "extend",
  menuIsOpen: true,
  departure: { label: null, coordinates: null },
  destination: { label: null, coordinates: null },
  modeTabs: "",
  distance: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_ITINERAIRE:
      return {
        ...state,
        selectedResult: -1,
        results: action.currentResults,
        isLoading: false,
        mode: "extend",
        departure: action.departure,
        destination: action.destination
      };
    case SEARCH_LOOP:
      return {
        ...state,
        selectedResult: -1,
        results: action.currentResults,
        isLoading: false,
        mode: "extend",
        departure: action.departure,
        destination: action.destination
      };
    case RESET_RESULTS:
      return {
        ...state,
        selectedTheme: {},
        selectedResult: -1,
        results: [],
        departure: { label: null, coordinates: null },
        destination: { label: null, coordinates: null },
        isLoading: false
      };
    case SELECT_THEME:
      return {
        ...state,
        selectedTheme: action.theme,
        selectedResult: action.result
      };
    case RESET_THEME:
      return {
        ...state,
        selectedTheme: {}
      };
    case CHANGE_MODE:
      return {
        ...state,
        mode: action.value
      };
    case SELECT_RESULT:
      return {
        ...state,
        selectedResult: action.value
      };
    case LOADING:
      return { ...state, isLoading: !state.isLoading };
    case SWITCH_MENU_STATE:
      return { ...state, menuIsOpen: !state.menuIsOpen };
    case UPDATE_DEPARTURE:
      return {
        ...state,
        departure: action.departure,
        isLoading: false
      };
    case UPDATE_DESTINATION:
      return {
        ...state,
        destination: action.destination,
        isLoading: false
      };
    case CHANGE_MODE_TABS:
      return { ...state, modeTabs: action.mode };
    case GET_LOOP_DATA:
      return {
        ...state,
        distance: action.distance,
        departure: action.departure,
        isLoading: true,
        results: action.results
      };
    default:
      return state;
  }
};

export const searchItineraire = (departure, destination) => (
  dispatch,
  getState
) => {
  dispatch({
    type: LOADING
  });
  const currentCity = getState().map.city;
  const currentResults = theme.filter(
    filterTheme => currentCity.theme.indexOf(filterTheme.id) >= 0
  );
  const allPromises = [];
  currentResults.map(currentTheme =>
    allPromises.push(
      new Promise((resolve, reject) => {
        GetItinerary(
          currentTheme.id,
          departure.toString(),
          destination.toString()
        ).then(data => {
          currentTheme.data.length = 0;

          if (data && data.routes) {
            data.routes.forEach(route => {
              const lineArray = [];
              route.legs.forEach(leg =>
                leg.steps.forEach(step => {
                  let mode = "walking";
                  // Mode names are currently not configurable in OSRM
                  // Therefore using this inadequate value 'pushing bike' in order to represent the crossings
                  if (step.mode === "pushing bike") {
                    mode = "crossing";
                  }
                  lineArray.push(
                    lineString(step.geometry.coordinates, { mode })
                  );
                })
              );
              currentTheme.data.push({
                distance: Math.round(route.distance / 100) / 10,
                time: Math.round(route.duration / 60),
                path: featureCollection(lineArray)
              });
            });
            resolve(true);
          } else {
            reject();
          }
        });
      })
    )
  );
  Promise.all(allPromises)
    .then(() => {
      dispatch({
        type: SEARCH_ITINERAIRE,
        currentResults,
        departure: { label: null, coordinates: departure },
        destination: { label: null, coordinates: destination }
      });
    })
    .catch(() => {
      dispatch({
        type: RESET_RESULTS
      });
    });
};

export const searchLoop = (departure, themes) => (dispatch, getState) => {
  dispatch({
    type: LOADING
  });
  const currentCity = getState().map.city;
  const currentResults = themes
    .filter(filterTheme => currentCity.theme.indexOf(filterTheme.id) >= 0)
    .filter(filterTheme => filterTheme.id !== "shortest");
  const allPromises = [];
  currentResults.map(currentTheme =>
    allPromises.push(
      new Promise((resolve, reject) => {
        GetLoop(
          currentTheme.id,
          departure.toString(),
          currentTheme.checkpoints
        ).then(data => {
          currentTheme.data.length = 0;
          if (data && data.routes) {
            data.routes.forEach(route => {
              const lineArray = [];
              route.legs.forEach(leg =>
                leg.steps.forEach(step =>
                  lineArray.push(
                    lineString(step.geometry.coordinates, { mode: "walking" })
                  )
                )
              );
              currentTheme.data.push({
                distance: Math.round(route.distance / 100) / 10,
                time: Math.round(route.duration / 60),
                path: featureCollection(lineArray)
              });
            });
            resolve(true);
          } else {
            reject();
          }
        });
      })
    )
  );
  Promise.all(allPromises)
    .then(() => {
      dispatch({
        type: SEARCH_LOOP,
        currentResults,
        departure: { label: null, coordinates: departure },
        destination: { label: null, coordinates: null }
      });
    })
    .catch(() => {
      dispatch({
        type: RESET_RESULTS
      });
    });
};

export const resetResults = () => dispatch => {
  dispatch({
    type: RESET_RESULTS
  });
};

export const selectTheme = currentTheme => dispatch => {
  dispatch({
    type: SELECT_THEME,
    theme: currentTheme,
    result: 0
  });
};

export const resetTheme = () => dispatch => {
  dispatch({
    type: RESET_THEME
  });
};

export const changeMode = mode => dispatch => {
  dispatch({
    type: CHANGE_MODE,
    value: mode
  });
};

export const changeSelectedResult = result => dispatch => {
  dispatch({
    type: SELECT_RESULT,
    value: result
  });
};

export const previousTheme = () => (dispatch, getState) => {
  const currentResults = getState().search.results;
  const currentThemeIndex = currentResults.findIndex(
    result => result.id === getState().search.selectedTheme.id
  );
  let previousThemeIndex;

  if (currentThemeIndex === 0) {
    previousThemeIndex = currentResults.length - 1;
  } else {
    previousThemeIndex = currentThemeIndex - 1;
  }

  dispatch({
    type: SELECT_THEME,
    theme: currentResults[previousThemeIndex],
    result: 0
  });
};

export const nextTheme = () => (dispatch, getState) => {
  const currentResults = getState().search.results;
  const currentThemeIndex = currentResults.findIndex(
    result => result.id === getState().search.selectedTheme.id
  );
  let nextThemeIndex;

  if (currentThemeIndex === currentResults.length - 1) {
    nextThemeIndex = 0;
  } else {
    nextThemeIndex = currentThemeIndex + 1;
  }

  dispatch({
    type: SELECT_THEME,
    theme: currentResults[nextThemeIndex],
    result: 0
  });
};

export const switchMenuState = () => dispatch => {
  dispatch({
    type: SWITCH_MENU_STATE
  });
};

export const updateDeparture = (label, coordinates) => dispatch => {
  if (!label && coordinates) {
    GetLabelLocation(coordinates).then(value => {
      dispatch({
        type: UPDATE_DEPARTURE,
        departure: {
          label: value[0].place_name,
          coordinates
        }
      });
    });
  } else if (label && coordinates) {
    dispatch({
      type: UPDATE_DEPARTURE,
      departure: {
        label,
        coordinates
      }
    });
  } else {
    dispatch({
      type: UPDATE_DEPARTURE,
      departure: {
        label: null,
        coordinates: null
      }
    });
  }
};

export const updateDestination = (label, coordinates) => dispatch => {
  if (coordinates) {
    GetLabelLocation(coordinates).then(value => {
      dispatch({
        type: UPDATE_DESTINATION,
        destination: {
          label: value[0].place_name,
          coordinates
        }
      });
    });
  } else if (label && coordinates) {
    dispatch({
      type: UPDATE_DESTINATION,
      destination: {
        label,
        coordinates
      }
    });
  } else {
    dispatch({
      type: UPDATE_DESTINATION,
      destination: {
        label: null,
        coordinates: null
      }
    });
  }
};

export const changeModeTabs = mode => dispatch => {
  dispatch({
    type: CHANGE_MODE_TABS,
    mode
  });
};

export const displayLoading = () => dispatch => {
  dispatch({
    type: LOADING
  });
};

export const getLoopData = (label, coordinates, distance) => dispatch => {
  dispatch({
    type: GET_LOOP_DATA,
    distance,
    departure: {
      label,
      coordinates
    },
    results: []
  });
};



// WEBPACK FOOTER //
// ./src/modules/search.js